import { _ as _objectSpread2 } from '../../dist/objectSpread2-811c5212.esm.js';
import 'core-js/modules/es.object.assign.js';
import { createStorage } from '@livepeer/core-react';
import { createReactClient as createReactClient$1 } from '@livepeer/core-react/client';
export { defaultQueryClient } from '@livepeer/core-react/client';

function _objectDestructuringEmpty(obj) {
  if (obj == null) throw new TypeError("Cannot destructure " + obj);
}

function createReactClient(_ref) {
  var config = Object.assign({}, (_objectDestructuringEmpty(_ref), _ref));
  return createReactClient$1(_objectSpread2({
    storage: typeof window !== 'undefined' ? config.storage ? config.storage : createStorage({
      storage: window.localStorage
    }) : undefined
  }, config));
}

export { createReactClient };
